// extracted by mini-css-extract-plugin
export var productImage = "_oj-1";
export var viewLink = "_oj-2";
export var wishlistItem = "_oj-0";